import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { PageContentDto } from '../../../services/dtos/page-content.dto';
import { getPageContent, toPageContentDTO } from '../../../services/page.service';
import { showAxiosMessageError } from '../../../services/error-message.service';
import MovingInBillUi from '../../../components/user-interfaces/moving-in/moving-in-bill/moving-in-bill.ui';

/**
 * Page de rattachement de contrat
 * @constructor
 */
export default function MovingInBillPage() {
    const navigate = useNavigate();
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);

    // Déclaration du loader pour l'affichage du Skeleton
    const [loading, setLoading] = useState<boolean>(true);
    // Bool pour éviter le spam du bouton Valider
    const [bill, setBill] = useState<string>('t');

    /**
     * Changement sur bouton radio
     * @param e Infos du form
     * @param value
     */
    const handlerChangeBill = (e: ChangeEvent<HTMLInputElement>, value: string) => {
        // Avez-vous une factue ? oui ou non
        setBill(value);
    };

    /**
     * Comportement à la soumission du formulaire
     */
    const handlerNavigate = () => {
        // Navigation des las pages selon si on veut rattacher un contrat ou non à l'emmenagement
        if (bill === 't') {
            navigate('/j-emmenage/rattachement-contrat');
        } else {
            navigate('/j-emmenage/etape-une');
        }
    };
    //Création de données par défaut pour la page
    const [pageContent, setPageContent] = useState<PageContentDto>({
        content: undefined,
        title: undefined,
        image: '../../../assets/images/logo-sddea.png',
    });

    // Récupère les données du back permettant de construire la page
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        getPageContent('emmenage')
            .then(async result => {
                //On met le résultat de la request dans la variable envoyée à la page
                if (result) {
                    setPageContent(await toPageContentDTO(result));
                }
                setLoading(false);
            })
            .catch(error => {
                //Affichage du message d'erreur si la request ne récupère rien
                console.error('Erreur lors de la récupération du contenu de la page');
                showAxiosMessageError(error, showMessage);
            });

        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Appel de l'interface, qui contiendra le form
    return (
        <MovingInBillUi
            handlerChangeBill={handlerChangeBill}
            handlerNavigate={handlerNavigate}
            pageContent={pageContent}
            loading={loading}
            billRadioValue={bill}
        />
    );
}
